export default __webpack_public_path__ + "static/media/icon_video_play.9403ad9e.svg";